/*
 * ---------------------------------------------------------------------------
 * Good-Natured - Slider
 * ---------------------------------------------------------------------------
 * Produktgalerie
 *   Natives Scroll-Snap-Karussell mit Endlos-Loop, 1:1 uebernommen von
 *   anothercotton.com (running-pdp.js/.css):
 *     Track:  display:flex; overflow-x:auto; overflow-y:hidden;
 *             scroll-snap-type:x mandatory; scroll-padding:0
 *     Slide:  scroll-snap-align:start
 *     Loop:   je ein geklonter Slide vorne/hinten, nach dem Einrasten springt
 *             die Scroll-Position lautlos zurueck
 *   Laeuft auf Handy und Desktop, mit eigenen Pfeilen und Punkten.
 *
 * Alle uebrigen Karussells (Produktkarten, "Interessante Artikel", ...)
 *   Dieselben Track-Regeln wie die Galerie, kein Loop, keine Klone, keine
 *   eigene Bedienlogik. Ohne Klone stimmt die Zaehlung des Themes wieder,
 *   deshalb bleiben die Punkte unangetastet in Betrieb. Die Pfeil-Buttons
 *   sind ausgeblendet.
 *
 * Drei Regeln, die leicht untergehen und alle drei gebraucht werden:
 *   overflow-y:hidden   sonst laesst sich der Streifen schraeg verschieben
 *   scroll-padding:0    sonst rastet ein Slide eingerueckt ein und links
 *                       bleibt ein Rest des vorherigen Bildes stehen
 *   outsetGutter()      ein padding-left am Scroll-Container liegt INNERHALB
 *                       des Scrollbereichs und scrollt mit scroll-padding:0
 *                       weg. Klebt der Track am Bildschirmrand, wandert dieser
 *                       Abstand deshalb nach aussen. Sitzt der Track dagegen
 *                       schon in einem eingerueckten Container, bleibt alles
 *                       wie es ist - sonst waere der Rand doppelt.
 * ---------------------------------------------------------------------------
 */
(function () {
  'use strict';

  var instances = [];
  window.gnSplideInstances = instances;

  /* =========================================================================
   * CSS
   * ========================================================================= */

  var TRACK_RULES = [
    'overflow-x:auto !important;',
    'overflow-y:hidden !important;',
    'scroll-snap-type:x mandatory !important;',
    'scroll-padding:0 !important;',
    'scroll-padding-left:0 !important;',
    'scroll-padding-right:0 !important;',
    '-webkit-overflow-scrolling:touch;',
    'overscroll-behavior-x:contain;',
    'scrollbar-width:none;',
    '-ms-overflow-style:none;'
  ].join('');

  var CSS = [
    'media-gallery.gn-rp{display:block;position:relative}',
    '.gn-rp .thumbnail-slider{display:none !important}',
    '.gn-rp slider-component .slider-buttons{display:none !important}',
    '.gn-rp-dots{display:flex;align-items:center;justify-content:center;width:100%}',
    '@media screen and (min-width:750px){.gn-rp-dots{display:none}}',

    '.gn-rp .product__media-list{',
    'position:relative;',
    'display:flex !important;',
    'flex-wrap:nowrap !important;',
    TRACK_RULES,
    'gap:0 !important;',
    'column-gap:0 !important;',
    'row-gap:0 !important;',
    'margin:0 !important;',
    'padding:0 !important;',
    'width:100% !important;',
    'max-width:100% !important;',
    'list-style:none;',
    '}',
    '.gn-rp .product__media-list::-webkit-scrollbar{width:0;height:0;display:none}',
    '.gn-rp .product__media-list::after{content:none !important;display:none !important;padding:0 !important;margin:0 !important;width:0 !important}',

    '.gn-rp .product__media-item{',
    'display:block !important;',
    'flex:0 0 100% !important;',
    'width:100% !important;',
    'min-width:100% !important;',
    'max-width:100% !important;',
    'margin:0 !important;',
    'padding:0 !important;',
    'scroll-snap-align:start;',
    '}',
    '.gn-rp .product__media-item .product-media-container,',
    '.gn-rp .product__media-item .media{background:#e8e8e6}',

    '.gn-rp-arrow{',
    'position:absolute;top:50%;transform:translateY(-50%);z-index:2;',
    'width:40px;height:40px;display:flex;align-items:center;justify-content:center;',
    'background:transparent;border:0;padding:0;cursor:pointer;',
    'color:#233732;opacity:.8;transition:opacity .2s;',
    '}',
    '.gn-rp-arrow:hover{opacity:1}',
    '.gn-rp-arrow svg{width:22px;height:22px;display:block}',
    '.gn-rp-arrow--prev{left:4px}',
    '.gn-rp-arrow--next{right:4px}',
    '@media screen and (max-width:900px){.gn-rp-arrow{display:none}}',

    '.gn-rp-progress{display:flex;gap:7px;margin:14px auto 0;max-width:150px;padding:0}',
    '.gn-rp-progress__bar{flex:1 1 0;height:1.5px;background:#E1E4D9;position:relative;border:0;padding:0;cursor:pointer;appearance:none;-webkit-appearance:none}',
    '.gn-rp-progress__bar::after{content:"";position:absolute;left:0;right:0;top:-11px;bottom:-11px}',
    '.gn-rp-progress__bar.is-active{background:#233732}',
    '@media screen and (max-width:749px){.gn-rp-progress{display:none}}',

    /* --- Uebrige Karussells: gleiche Track-Regeln, sonst nichts ---------- */
    '.gn-rc{' + TRACK_RULES + '}',
    '.gn-rc::-webkit-scrollbar{width:0;height:0;display:none}',
    '.gn-rc > li,',
    '.gn-rc > .slider__slide,',
    '.gn-rc > .grid__item{scroll-snap-align:start;}',

    'slider-component:has(.gn-rc) .slider-buttons .slider-button{display:none !important}',
    '.gn-rc ~ .slider-buttons .slider-button{display:none !important}',

    '.gn-rp-nosnap{scroll-snap-type:none !important;scroll-behavior:auto !important}'
  ].join('');

  function injectCSS() {
    if (document.getElementById('gn-rp-gallery-css')) return;
    var s = document.createElement('style');
    s.id = 'gn-rp-gallery-css';
    s.appendChild(document.createTextNode(CSS));
    (document.head || document.documentElement).appendChild(s);
  }

  injectCSS();

  /* =========================================================================
   * Helfer
   * ========================================================================= */

  var SVG_PREV =
    '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">' +
    '<path d="M8.9994 12.0001L13.242 16.2427L14.6562 14.8285L11.8278 12.0001L14.6562 9.17166L13.242 7.75746L8.9994 12.0001Z" fill="currentColor"/></svg>';
  var SVG_NEXT =
    '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">' +
    '<path d="M15.0006 12.0001L10.758 16.2427L9.34375 14.8285L12.1722 12.0001L9.34375 9.17166L10.758 7.75746L15.0006 12.0001Z" fill="currentColor"/></svg>';

  function toArray(list) {
    return Array.prototype.slice.call(list || []);
  }

  function closest(el, sel) {
    return el && el.closest ? el.closest(sel) : null;
  }

  function realSlides(track) {
    return toArray(track.children).filter(function (el) {
      return el.nodeType === 1 && !el.hasAttribute('data-gn-clone');
    });
  }

  function offsetsOf(state) {
    var kids = state.track.children;
    var arr = [];
    for (var i = 0; i < kids.length; i++) arr.push(kids[i].offsetLeft);
    return arr;
  }

  function leftOfRaw(state, raw) {
    var offs = offsetsOf(state);
    if (!offs.length) return 0;
    raw = Math.max(0, Math.min(offs.length - 1, raw));
    return offs[raw];
  }

  function rawIndex(state) {
    var offs = offsetsOf(state);
    var sl = state.track.scrollLeft;
    var best = 0;
    var bestDist = Infinity;
    for (var i = 0; i < offs.length; i++) {
      var d = Math.abs(offs[i] - sl);
      if (d < bestDist) {
        bestDist = d;
        best = i;
      }
    }
    state.dist = bestDist;
    return best;
  }

  function realIndex(state) {
    var i = rawIndex(state) - state.offset;
    var n = state.n;
    return ((i % n) + n) % n;
  }

  function scrollToRaw(state, raw, smooth) {
    var left = leftOfRaw(state, raw);
    if (smooth && state.track.scrollTo) {
      state.track.scrollTo({ left: left, behavior: 'smooth' });
    } else {
      state.track.scrollLeft = left;
    }
  }

  function jumpToRaw(state, raw) {
    var t = state.track;
    var left = leftOfRaw(state, raw);
    state.jumping = true;
    t.classList.add('gn-rp-nosnap');
    t.style.scrollBehavior = 'auto';
    t.scrollLeft = left;
    t.style.scrollBehavior = '';
    void t.offsetWidth;
    t.classList.remove('gn-rp-nosnap');
    state.jumping = false;
  }

  /* =========================================================================
   * Galerie-Mechanik
   * ========================================================================= */

  function updateUI(state) {
    applyIndex(state, realIndex(state));
  }

  /* Nur die Bedienelemente. Die Slides selbst werden hier bewusst NICHT
     angefasst: eine Klassenaenderung an den Kindern eines Scroll-Snap-
     Containers laesst Chrome neu einrasten und bricht dabei eine laufende
     Scroll-Animation ab. Das uebernimmt syncSlides() im Ruhezustand. */
  function applyIndex(state, idx) {
    if (idx === state.lastIdx) return;
    state.lastIdx = idx;

    for (var d = 0; d < state.dots.length; d++) {
      var on = d === idx;
      state.dots[d].classList.toggle('active-section-dot', on);
      state.dots[d].classList.toggle('gn-dot-active', on);
    }

    for (var b = 0; b < state.bars.length; b++) {
      state.bars[b].classList.toggle('is-active', b === idx);
    }
  }

  function syncSlides(state, idx) {
    var reals = state.reals;
    for (var i = 0; i < reals.length; i++) {
      var on = i === idx;
      if (reals[i].classList.contains('is-active') !== on) {
        reals[i].classList.toggle('is-active', on);
      }
    }
  }

  function releaseAnimation(state) {
    clearTimeout(state.animTimer);
    state.animating = false;
    state.targetRaw = null;
  }

  function settle(state) {
    if (state.jumping) return;

    var nearest = rawIndex(state);
    if (state.dist > 2) return;

    if (state.loop) {
      if (nearest < state.offset) {
        jumpToRaw(state, nearest + state.n);
      } else if (nearest > state.offset + state.n - 1) {
        jumpToRaw(state, nearest - state.n);
      }
    }

    clearTimeout(state.animTimer);
    state.animating = false;
    state.targetRaw = null;
    state.lastIdx = -1;
    updateUI(state);
    syncSlides(state, state.lastIdx);
  }

  function move(state, dir) {
    var base = state.animating && state.targetRaw != null ? state.targetRaw : rawIndex(state);
    var raw = base + dir;

    if (state.loop) {
      if (raw > state.offset + state.n) {
        jumpToRaw(state, base - state.n);
        base = base - state.n;
        raw = base + dir;
      } else if (raw < state.offset - 1) {
        jumpToRaw(state, base + state.n);
        base = base + state.n;
        raw = base + dir;
      }
    } else {
      raw = Math.max(0, Math.min(state.n - 1, raw));
    }

    startMove(state, raw);
  }

  function startMove(state, raw) {
    state.targetRaw = raw;
    state.animating = true;
    scrollToRaw(state, raw, true);

    var n = state.n;
    var idx = (((raw - state.offset) % n) + n) % n;
    state.lastIdx = -1;
    applyIndex(state, idx);

    clearTimeout(state.animTimer);
    state.animTimer = setTimeout(function () {
      state.animating = false;
      state.targetRaw = null;
    }, 700);
  }

  function goToReal(state, idx, smooth) {
    if (smooth === false) {
      scrollToRaw(state, idx + state.offset, false);
      return;
    }
    startMove(state, idx + state.offset);
  }

  function bindEvents(state) {
    var track = state.track;
    if (track.gnRpBound) return;
    track.gnRpBound = true;

    var settleTimer = null;
    var touching = false;

    function scheduleSettle(delay) {
      clearTimeout(settleTimer);
      settleTimer = setTimeout(function () {
        if (!touching) settle(track.gnRp || state);
      }, delay);
    }

    track.addEventListener('scroll', function () {
      var st = track.gnRp || state;
      if (!st.animating) {
        if (st.raf) cancelAnimationFrame(st.raf);
        st.raf = requestAnimationFrame(function () { updateUI(st); });
      }
      scheduleSettle(90);
    }, { passive: true });

    if ('onscrollend' in window) {
      track.addEventListener('scrollend', function () {
        if (!touching) settle(track.gnRp || state);
      });
    }

    function interrupt() { releaseAnimation(track.gnRp || state); }

    track.addEventListener('touchstart', function () { touching = true; interrupt(); }, { passive: true });
    track.addEventListener('pointerdown', interrupt, { passive: true });
    track.addEventListener('wheel', interrupt, { passive: true });
    track.addEventListener('touchend', function () { touching = false; scheduleSettle(120); }, { passive: true });
    track.addEventListener('touchcancel', function () { touching = false; scheduleSettle(120); }, { passive: true });
  }

  /* =========================================================================
   * Produktgalerie
   * ========================================================================= */

  function makeArrow(state, dir) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'gn-rp-arrow gn-rp-arrow--' + (dir < 0 ? 'prev' : 'next');
    b.setAttribute('aria-label', dir < 0 ? 'Vorheriges Bild' : 'Naechstes Bild');
    b.innerHTML = dir < 0 ? SVG_PREV : SVG_NEXT;
    b.addEventListener('click', function (e) { e.preventDefault(); move(state, dir); });
    return b;
  }

  function makeDotButton(state, dir) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'slider-button slider-button--' + (dir < 0 ? 'prev' : 'next');
    b.setAttribute('aria-label', dir < 0 ? 'Vorheriges Bild' : 'Naechstes Bild');
    b.innerHTML = dir < 0 ? SVG_PREV : SVG_NEXT;
    b.addEventListener('click', function (e) { e.preventDefault(); move(state, dir); });
    return b;
  }

  function buildControls(state, mg) {
    var viewer = state.viewer;

    toArray(mg.querySelectorAll('.gn-rp-arrow, .gn-rp-progress, .gn-rp-dots')).forEach(function (n) {
      n.parentNode.removeChild(n);
    });

    state.dots = [];
    state.bars = [];

    viewer.appendChild(makeArrow(state, -1));
    viewer.appendChild(makeArrow(state, 1));

    var row = document.createElement('div');
    row.className = 'slider-buttons quick-add-hidden gn-rp-dots';

    state.prevBtn = makeDotButton(state, -1);
    state.nextBtn = makeDotButton(state, 1);

    var counter = document.createElement('div');
    counter.className = 'slider-counter caption';

    var i;
    for (i = 0; i < state.n; i++) {
      (function (index) {
        var dot = document.createElement('div');
        dot.className = 'mobile-slider-dot-container--dot';
        dot.setAttribute('dot-id', index + 1);
        dot.style.cursor = 'pointer';
        dot.addEventListener('click', function () { goToReal(state, index, true); });
        counter.appendChild(dot);
        state.dots.push(dot);
      })(i);
    }

    row.appendChild(state.prevBtn);
    row.appendChild(counter);
    row.appendChild(state.nextBtn);

    var progress = document.createElement('div');
    progress.className = 'gn-rp-progress';

    for (i = 0; i < state.n; i++) {
      (function (index) {
        var bar = document.createElement('button');
        bar.type = 'button';
        bar.className = 'gn-rp-progress__bar';
        bar.setAttribute('aria-label', 'Bild ' + (index + 1));
        bar.addEventListener('click', function () { goToReal(state, index, true); });
        progress.appendChild(bar);
        state.bars.push(bar);
      })(i);
    }

    var anchor = viewer.parentNode === mg ? viewer.nextSibling : null;
    if (anchor || viewer.parentNode === mg) {
      mg.insertBefore(row, anchor);
      mg.insertBefore(progress, anchor);
    } else {
      mg.appendChild(row);
      mg.appendChild(progress);
    }
  }

  function galleryClone(slide) {
    var c = slide.cloneNode(true);
    c.setAttribute('data-gn-clone', '');
    c.setAttribute('aria-hidden', 'true');
    c.removeAttribute('id');
    c.removeAttribute('data-media-id');
    c.classList.remove('is-active');
    toArray(c.querySelectorAll('[id]')).forEach(function (el) { el.removeAttribute('id'); });
    toArray(c.querySelectorAll('img')).forEach(function (img) {
      img.setAttribute('loading', 'eager');
      img.setAttribute('decoding', 'sync');
      img.removeAttribute('fetchpriority');
    });
    return c;
  }

  function buildGallery(mg) {
    var track = mg.querySelector('.product__media-list');
    if (!track) return;

    var viewer = mg.querySelector('[id^="GalleryViewer"]') || track.parentNode;

    mg.classList.add('gn-rp');

    if (!mg.gnSlideGuard) {
      mg.gnSlideGuard = true;
      mg.addEventListener('slideChanged', function (e) { e.stopPropagation(); }, true);
    }

    var state = { mg: mg, track: track, viewer: viewer };
    track.gnRp = state;
    mg.gnRp = state;

    state.suspendObserver = true;
    toArray(track.querySelectorAll('[data-gn-clone]')).forEach(function (n) {
      n.parentNode.removeChild(n);
    });

    var reals = realSlides(track);
    state.reals = reals;
    state.n = reals.length;
    state.dots = [];
    state.bars = [];
    state.lastIdx = -1;
    state.animating = false;
    state.targetRaw = null;

    if (state.n < 2) {
      state.loop = false;
      state.offset = 0;
      state.suspendObserver = false;
      track.gnRpReady = true;
      return;
    }

    state.loop = true;
    state.offset = 1;

    track.insertBefore(galleryClone(reals[state.n - 1]), track.firstChild);
    track.appendChild(galleryClone(reals[0]));
    state.suspendObserver = false;

    buildControls(state, mg);

    jumpToRaw(state, state.offset);
    state.lastIdx = -1;
    updateUI(state);
    syncSlides(state, state.lastIdx);

    bindEvents(state);
    track.gnRpReady = true;

    instances.push({ kind: 'gn-rp', track: track, state: state });
  }

  function scanGalleries() {
    var galleries = toArray(document.querySelectorAll('media-gallery'));
    for (var i = 0; i < galleries.length; i++) {
      var mg = galleries[i];
      if (closest(mg, 'quick-add-modal')) continue;
      var track = mg.querySelector('.product__media-list');
      if (!track) continue;
      if (track.gnRpReady && track.gnRp && track.gnRp.mg === mg) continue;
      try {
        buildGallery(mg);
      } catch (err) {
        if (window.console) console.warn('[gn-slider] Galerie uebersprungen:', err);
      }
    }
  }

  /* =========================================================================
   * Uebrige Karussells - nur Einrasten, keine eigene Logik
   * ========================================================================= */

  function isScroller(ul) {
    var cs = window.getComputedStyle(ul);
    if (cs.overflowX !== 'auto' && cs.overflowX !== 'scroll') return false;
    return ul.scrollWidth > ul.clientWidth + 4;
  }

  /* Seitlichen Innenabstand in einen Aussenabstand umwandeln, damit der Rand
     zum Bildschirm stehen bleibt statt weggescrollt zu werden.
     Nur wenn der Track wirklich am Bildschirmrand klebt - sitzt er schon in
     einem eingerueckten Container, liefert dieser den Rand bereits und ein
     zusaetzlicher Aussenabstand wuerde doppelt einruecken. */
  function outsetGutter(ul) {
    if (ul.dataset.gnGutter) return;

    var rect = ul.getBoundingClientRect();
    if (rect.left > 1) return;

    var cs = window.getComputedStyle(ul);
    var pl = parseFloat(cs.paddingLeft) || 0;
    var pr = parseFloat(cs.paddingRight) || 0;
    if (!pl && !pr) return;

    ul.dataset.gnGutter = pl + ',' + pr;
    ul.style.setProperty('padding-left', '0', 'important');
    ul.style.setProperty('padding-right', '0', 'important');
    if (pl) ul.style.setProperty('margin-left', pl + 'px', 'important');
    if (pr) ul.style.setProperty('margin-right', pr + 'px', 'important');
  }

  function scanCarousels() {
    var list = document.querySelectorAll('ul.slider, .slider--everywhere, .slider--desktop, .slider--tablet');
    for (var i = 0; i < list.length; i++) {
      var ul = list[i];
      try {
        if (ul.classList.contains('product__media-list')) continue;
        if (closest(ul, 'media-gallery')) continue;

        /* Reste aus der frueheren Loop-Variante entfernen. */
        var clones = ul.querySelectorAll('[data-gn-clone]');
        for (var c = 0; c < clones.length; c++) {
          if (clones[c].parentNode) clones[c].parentNode.removeChild(clones[c]);
        }
        ul.classList.remove('gn-rc-loop');

        if (isScroller(ul)) {
          outsetGutter(ul);
          ul.classList.add('gn-rc');
        } else {
          ul.classList.remove('gn-rc');
        }
      } catch (err) {}
    }
  }

  /* =========================================================================
   * Start
   * ========================================================================= */

  var resizeTimer = null;
  function onResize() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      for (var i = 0; i < instances.length; i++) {
        var st = instances[i].state;
        if (!st || !st.track || !st.track.isConnected || !st.loop) continue;
        var idx = st.lastIdx < 0 ? 0 : st.lastIdx;
        jumpToRaw(st, idx + st.offset);
      }
    }, 150);
  }

  function scan() {
    scanGalleries();
    scanCarousels();
  }

  var pending = null;
  function scheduleScan() {
    if (pending) clearTimeout(pending);
    pending = setTimeout(function () {
      pending = null;
      scan();
    }, 120);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }

  window.addEventListener('load', function () {
    scan();
    setTimeout(scan, 600);
  });

  window.addEventListener('resize', function () {
    scheduleScan();
    onResize();
  });

  window.addEventListener('orientationchange', function () {
    scheduleScan();
    onResize();
  });

  if (window.MutationObserver) {
    var observer = new MutationObserver(function (records) {
      for (var i = 0; i < records.length; i++) {
        var rec = records[i];
        if (!rec.addedNodes || !rec.addedNodes.length) continue;
        var t = rec.target;
        if (t && t.gnRp && t.gnRp.suspendObserver) continue;
        scheduleScan();
        return;
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  document.addEventListener('shopify:section:load', scheduleScan);
})();
